export default (function (_ref) {
  var colors = _ref.colors;
  return {
    divided: {
      borderTop: "2px solid ".concat(colors.primaryLight)
    }
  };
});